import $ from 'jquery';

const ready = function() {
  $('.close-button').click(function(e) {
    e.preventDefault();
    $('.nav-mobile').removeClass('visible');
  });

  $('.burger').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('.nav-mobile').addClass('visible');
  });

  $(window).on('click', function(e) {
    $('.nav-mobile').removeClass('visible');
  });

  $('.nav-mobile').click(function(e) {
    e.stopPropagation();
  });

  function bindHoverEffect() {
    if ($(window).width() >= 1025) {
      $('.news__box').each(function() {
        const $box = $(this);
        const $img = $box.find('.news__box-img');
        const $text = $box.find('.news__box-text');

        $img.on('mouseenter', function() {
          $text.addClass('active');
        });

        $box.on('mouseleave', function() {
          $text.removeClass('active');
        });
      });
    }
  }

  function resetHoverEffect() {
    $('.news__box-img').off('mouseenter');
    $('.news__box').off('mouseleave');
    bindHoverEffect();
  }

  bindHoverEffect();

  $(window).on('resize', function() {
    resetHoverEffect();
  });

  if ($(window).width() <= 1024) {
    $('a.news__box-img').on('click', function(e) {
      e.preventDefault();
      $('.news__box-text').toggleClass('active');
    });
    $('.news__box-close').on('click', function(e) {
      $('.news__box').hide();
    });
  }

  var $newsBox = $('.news__box');
  var $footer = $('footer');
  var boxHeight = $newsBox.outerHeight();
  var defaultBottom = 20; // отступ снизу по умолчанию

  function adjustNewsBoxPosition() {
    var windowBottom = $(window).scrollTop() + $(window).height();
    var footerTop = $footer.offset().top;

    if (windowBottom > footerTop) {
      // на сколько перекрывает футер
      var overlap = windowBottom - footerTop;
      var newBottom = defaultBottom + overlap;

      $newsBox.css('bottom', newBottom + 'px');
    } else {
      $newsBox.css('bottom', defaultBottom + 'px');
    }
  }

  adjustNewsBoxPosition();

  $(window).on('scroll resize', function() {
    adjustNewsBoxPosition();
  });
};

$(document).ready(ready);
